import { Component, inject } from "@angular/core";
import { RouterLink, RouterLinkActive } from "@angular/router";
import { TranslatePipe } from "@ngx-translate/core";
import { AppService } from "src/app-legacy/core/services/app.service";
import { AuthService } from "src/app-legacy/core/services/auth.service";
import { UserRoleService } from "src/app/core/services/user-role.service";
import { TopbarUserProfileMenuItemComponent } from "../topbar-user-profile-menu-item/topbar-user-profile-menu-item.component";

@Component({
	selector: "app-topbar-user-profile-menu",
	imports: [TopbarUserProfileMenuItemComponent, TranslatePipe, RouterLink, RouterLinkActive],
	templateUrl: "./topbar-user-profile-menu.component.html",
})
export class TopbarUserProfileMenuComponent {
	private readonly auth = inject(AuthService);
	private readonly appService = inject(AppService);
	public userRole = inject(UserRoleService);

	isInternalView = this.appService.currentSchool.zfInternalViewSchool === "YES";

	logOut(): void {
		this.auth.logOut();
	}
}
